import React from "react";
import {observable, action} from "mobx";
import {FreePlayContainerBox} from "./boxes/container/free-play-container.box";
import {observer} from "mobx-react";
import {VouchersSwiperComponent} from "./parts/voucher-card/swiper/vouchers-swiper.component";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {VoucherGamesListBox} from "./boxes/voucher-games-list/voucher-games-list.box";
import {VouchersSwiperTitleBox} from "./boxes/vouchers-swiper/vouchers-swiper-title.box";
import {VouchersSwiperBackgroundBox} from "./boxes/vouchers-swiper/vouchers-swiper-background.box";
import {VouchersGamesListTitleBox} from "./boxes/voucher-games-list-title/voucher-games-list-title.box";
import {CyClass} from "../../../common/cy-classes";
import {GameItemComponent} from "../game-item/game-item.component";

@observer
export class FreePlayContainerComponent extends OrbitComponent {
    @observable
    currentVoucherIndex = 0;

    @action
    private _onCurrentVoucherChangedHandler = (voucherIndex: number) => {
        this.currentVoucherIndex = voucherIndex;
    }

    private _renderVoucherGames = () => {
        const currentVoucher = this.services.freePlay.userVouchers[this.currentVoucherIndex];
        if(!currentVoucher) {
            return null;
        }

        return  (<VoucherGamesListBox className={CyClass('cy-free-play-games-container')}>
            {currentVoucher.freePlayGames.map(voucherGame => <GameItemComponent className={CyClass('cy-free-play-game-item')}
                                                                                gameType={voucherGame.gameInfo.gameType}
                                                                                key={currentVoucher.id + '_' + voucherGame.gameInfo.gameType}
                                                                                freePlayType={currentVoucher.freePlayType}
                                                                                onClickHandler={() => voucherGame.play()}
                                                                                style={{marginBottom: "1.5rem"}}
            />)}
        </VoucherGamesListBox>);
    }

    render() {


        return (
            <FreePlayContainerBox className={CyClass('cy-free-play-vouchers-container')}>
                <VouchersSwiperBackgroundBox>
                    <VouchersSwiperTitleBox>
                        {this.services.translation.translate('FREE_PLAY_MESSAGE_LIST_TITLE')}
                    </VouchersSwiperTitleBox>
                    <VouchersSwiperComponent onCurrentVoucherIndexChanged={this._onCurrentVoucherChangedHandler}/>
                </VouchersSwiperBackgroundBox>
                <VouchersGamesListTitleBox>
                    {this.services.translation.translate('FREE_PLAY_MESSAGE_GAMES_LIST_TITLE')}
                </VouchersGamesListTitleBox>
                {this._renderVoucherGames()}
            </FreePlayContainerBox>
        )
    }
}